<template>
    <div class="dd-l-section--product__container">
        <div class="dd-l-container__wrapper dd-l-container__wrapper--content">

            <div class="dd-l-section--product__content">
                <div class="dd-l-section--product__header">
                    <header class="dd-l-section--product__header-item">
                        <button @click.prevent="hide"
                                class="dd-m-button dd-m-button--auto dd-m-button--assertive dd-m-button--circled">
                            <i class="icon-close"></i>
                        </button>
                    </header>

                    <div class="dd-l-section--product__topbar">
                        <div class="dd-l-section--product__rating">
                            <span class="dd-m-icon icon-star"
                                  v-bind:class="{'dd-m-text--deactive' : i >= item.rating}"
                                  v-for="(i, index) in ratings"
                                  :key="index"></span>
                        </div>

                        <span class="dd-l-section--product__reviews" v-if="item.reviews">
                            [ {{item.reviews}} Reviews ]
                        </span>
                    </div>

                    <h1 class="dd-l-section--product__title">
                        {{item.name}}
                    </h1>

                </div>

                <h2 class="dd-l-section--product__title dd-l-section--product__title--it"
                    v-if="item.slogan">
                    {{item.slogan}}
                </h2>

                <div class="dd-l-section--product__description" v-if="item.short_description">
                    <p>
                        {{item.short_description}}
                    </p>
                </div>

                <div class="dd-m-gallery xxx2" v-if="item.image && item.image.mobile">
                    <div class="dd-m-carousel dd-m-carousel--custom-dots dd-m-carousel--gallery">
                        <div class="dd-m-gallery__featured-image" id="ddGalleryFeat">
                            <picture id="galleryFeaturedImage">
                                <img class="dd-mobile" :srcset="item.image.mobile" :alt="item.name">
                            </picture>
                        </div>
                    </div>
                </div>

                <div class="dd-l-section--product__extra-info"
                     v-if="item.link_representative || item.link_store">
                    <div class="dd-m-extra--custom-product-links">
                        <a class="dd-m-button dd-m-button--light dd-m-button--custom-big"
                           title="Buy Online"
                           v-if="item.link_store"
                           target="_blank"
                           :href="item.link_store">
                            Buy Online
                        </a>

                        <a class="dd-m-button dd-m-button--light dd-m-button--custom-big"
                           title="Find a Dealer"
                           v-if="item.link_representative"
                           target="_blank"
                           :href="item.link_representative">
                            Find a Dealer
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'card-product-offline',
        props: ['item', 'hide'],
        data: () => {
            return {
                ratings: []
            }
        },
        mounted() {
            this.buildRatingArr();
        },
        methods: {
            buildRatingArr() {
                this.item.rating = parseFloat(this.item.rating);
                this.ratings = [];

                for (let i = 0; i < 5; i++) {
                    this.ratings.push(i);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/card-product-info-offline.vue